import React, { FC } from "react";
import { Empty, Spin } from "antd";
import { TaskExecution } from "shared/api";
import { OverviewThisWeekTaskRow } from "./OverviewThisWeekTaskRow";

interface Props {
  isLoading: boolean;
  tasks: TaskExecution[];
  machinesNaLabel: string;
  unnamedTaskLabel: string;
  emptyDescription: string;
}

const OverviewThisWeekTasksContent: FC<Props> = ({
  isLoading,
  tasks,
  machinesNaLabel,
  unnamedTaskLabel,
  emptyDescription,
}) => {
  if (isLoading) {
    return (
      <div className="flex items-center justify-center py-10">
        <Spin />
      </div>
    );
  }

  if (tasks.length === 0) {
    return (
      <div className="flex items-center justify-center px-4 py-8">
        <Empty
          className="!my-0"
          description={emptyDescription}
          image={Empty.PRESENTED_IMAGE_SIMPLE}
        />
      </div>
    );
  }

  return (
    <ul className="m-0 list-none p-0">
      {tasks.map((exec) => (
        <OverviewThisWeekTaskRow
          key={exec.id}
          execution={exec}
          machinesNaLabel={machinesNaLabel}
          unnamedTaskLabel={unnamedTaskLabel}
        />
      ))}
    </ul>
  );
};

export { OverviewThisWeekTasksContent };
